export default "__VITE_ASSET__65SO2m_R__"